import React, {useContext, useState} from "react";
import TableCellComponent from "./TableCellComponent";
import {IconButton, makeStyles} from "@material-ui/core";
import {ScreenDesignerContextNew} from "../../../../../../../../ContextComponents/ScreenDesignerContextNew";
import {MoreVertOutlined} from "@material-ui/icons";
import ContextMenu from "./ContextMenu";

const useStyles = makeStyles(() => ({
    trMenu: {
        position: 'absolute',
        width: 40,
        left: -40,
        top: 0,
        border: '1px solid #dedede',
        height: '100%',
        borderRadius: 8,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    trWrap: {
        position: 'relative',
        '& $trMenu': {
            visibility: 'hidden',
        },
        '&:hover': {
            '& $trMenu': {
                visibility: 'visible',
            }
        }
    },
    tr: {
        position: 'relative',
        '& $td:nth-child(1)': {
            borderLeft: '1px solid',
            borderRight: '1px solid',
        },
        '& $td': {
            borderLeft: '1px solid',
            borderBottom: '1px solid',
            borderRight: '1px solid',
        },
        '& $th': {
            border: '1px solid',
        },
    }
}))

const initialContextState = {
    mouseX: null,
    mouseY: null,
};

const TableRowComponent = ({rowIndex, component, path, columns}) => {
    const {children} = component;
    const classes = useStyles();
    const {onDropComponent, onDeleteComponent} = useContext(ScreenDesignerContextNew);
    const [contextMenu, setContextMenu] = useState(initialContextState);
    const closeContextMenu = () => {
        setContextMenu(initialContextState)
    };
    function addRow(direction) {

        if (!columns.length) return;

        const newItem = {
            type: 'tableTr',
            properties: {},
            styles: [],
            children: new Array(columns.length).fill({type: 'tableTd', properties: {}, children: []})
        };

        onDropComponent(newItem, rowIndex + direction, `${path}.children`)
    }


    function removeRow(e) {
        onDeleteComponent(`${path}.children.${rowIndex}`, component.type)
    }

    function duplicateRow() {
        onDropComponent(component, rowIndex + 1, `${path}.children`)
    }

    return (
        <>
            <tbody className={classes.trWrap}>
            <tr key={rowIndex} style={{height: '50px'}} className={classes.tr}>
                {children?.map((td, cellIndex) => {
                    return (
                        <TableCellComponent
                            key={rowIndex + "_" + cellIndex}
                            rowIndex={rowIndex}
                            cellIndex={cellIndex}
                            component={td}
                            path={path + '.children.' + rowIndex + ".children." + cellIndex}
                            parentPath={path}
                        />
                    )
                })}
            </tr>
            <div className={classes.trMenu}>
                <IconButton
                    onClick={(e) => setContextMenu({mouseX: e.clientX - 2,mouseY: e.clientY - 4})}
                    size="small">
                    <MoreVertOutlined/>
                </IconButton>
            </div>
            </tbody>
            <ContextMenu
                contextMenu={contextMenu}
                onClose={closeContextMenu}
                removeItem={removeRow}
                addItem={addRow}
                duplicateItem={duplicateRow}
            />
        </>
    )
}

export default TableRowComponent;